import {
  Injectable,
  ComponentFactoryResolver,
  ViewContainerRef,
  Type,
  ComponentRef,
  ɵComponentFactory,
} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { EntryfordayAdapter } from "../../adapter/entryforday.adapter";
import { GLOBAL, WEEKOFF_DATA } from "src/app/app.globals";
import { map } from "rxjs/operators";
import { Contractor } from "../../entryfortheday/entryforday.model";

@Injectable()
export class WageRegisterFormBService {
  httpClient: any;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private http: HttpClient,
    private adapter: EntryfordayAdapter
  ) {}

  public createComponent<T>(
    viewContainerRef: ViewContainerRef,
    type: Type<T>
  ): ComponentRef<T> {
    const componentFactory: ɵComponentFactory<T> =
      this.componentFactoryResolver.resolveComponentFactory(type);
    return viewContainerRef.createComponent(componentFactory);
  }
  public getContractors(
    excludeContractorCode: string = "",
    workOrderCode: any = ""
  ): Observable<any[]> {
    const req = {
      search: null,
      sDate: null,
      eDate: null,
      selectedField: null,
      isMain: workOrderCode ? "0" : "1",
      Contractor_Code: null,
      ExcludeContractor_Code: null,
      workOrderCode: workOrderCode ? workOrderCode : null,
      Plant_Code: null,
      UserID: "142", // localStorage.getItem('UserID'),
      RequirType: null,
    };
    const url = `${GLOBAL.APIS.WORK_ORDER.SP_Listing_Contractor_Filter_V1}`;
    // console.log(url);
    return this.http
      .post<any[]>(url, req)
      .pipe(map((response: any) => response));
  }
  public getContractorsNewSP(dataObj: any): Observable<any[]> {
    const url = `${GLOBAL.APIS.WORK_ORDER.SP_Listing_Contractor_Filter_V1}`;
    return this.http.post<any[]>(url, dataObj);
  }
  public getJoiningAndResigningData(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}SP_RPT_COM_MTorITorPV`;
    return this.http.post(url, data);
  }

  public getContractorsbydefault(
    userId: any,
    roleCode: any
  ): Observable<any[]> {
    const url = `${GLOBAL.APIS.WORK_ORDER.GET_BYDEFAULTCONTRACTORS}?UserId=${GLOBAL.USER.LOGGED_IN_USER}&RoleCode=${GLOBAL.USER.ROLE_CODE}`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }
  public getPunchFromReaderDetails(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.REPORTS.GET_PUNCH_FROM_READER}`;
    console.log("URL", url);
    console.log("DATA", data);
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
  }
  public getFormDDetails(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.REPORTS.GET_FORM_D_REPORT}`;
    console.log("GET_FORM_D_REPORT", url);
    console.log("GET_FORM_D_REPORTData", data);
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response.Data.objContractor));
  }
  public getDailyPresentDetails(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.REPORTS.GET_DAILY_PRESENT}`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
  }

  public getLabourDetails(data: any): Observable<any[]> {
    const url = `${GLOBAL.APIS.COMPANY_COMMONS_MASTER.GET_EMP}`;
    return this.http.post(url, data).pipe(map((response: any) => response));
  }

  public getRole(userId: any): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_ROLEBYDEFAULT}?UserId=${GLOBAL.USER.LOGGED_IN_USER}`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }

  public getCoffFilterData(data: any): Observable<any[]> {
    const url = `${GLOBAL.APIS.COMPANY_COMMONS_MASTER.GET_COFFDATA_LISTING}`;
    return this.http.post(url, data).pipe(map((response: any) => response));
  }

  public getLabourdaviationallow(data: any): Observable<any[]> {
    const url = `${GLOBAL.APIS.COMPANY_COMMONS_MASTER.GET_LABOUR}`;
    return this.http.post(url, data).pipe(map((response: any) => response));
  }

  public getShiftTypeGroups(): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_SHIFTTYPEGROUP_DATA}?Search=&PlantCode=`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }

  public getStateForFormDReport(): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_SHIFTTYPEGROUP_DATA}?Search=&PlantCode=`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }
  public getManPowerReqVSAllocationSummary(data: any): Observable<any> {
    // return of(this.getSummaryReportData());
    const url = `${GLOBAL.APIS.REPORTS.GET_MANPOWERREQVSREQ_SUMMARY_REPORT}`;
    //    console.log('URL getDailyPresentDetails', url);
    //   console.log('DATA getDailyPresentDetails', data);
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
  }
  public getMonthlyOTReport(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.REPORTS.GET_MONTHLY_ATT_WITH_OT_REPORT}`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response.Data.Table));
  }
  public getLabourPerformanceReportData(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.REPORTS.GET_TIMECARD_DATA}`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
  }
  public getTimeCardPlantWiseReportData(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.REPORTS.GET_TIMECARD_PlantWise_DATA}`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
  }
  public getDailyUnitwisePresentDetails(data: any): Observable<any> {
    // const url = `${GLOBAL.APIS.REPORTS.GET_UNITWISE_PRESENT}`;
    const url = `${GLOBAL.APIS.REPORTS.GET_UNITWISE_PRESENT_CMN}`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
  }
  public getDailyUnitwiseAbsentDetails(data: any): Observable<any> {
    // const url = `${GLOBAL.APIS.REPORTS.GET_UNITWISE_PRESENT}`;
    const url = `${GLOBAL.APIS.REPORTS.GET_UNITWISE_ABSENT_CMN}`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
  }

  public getDailyEarlyOutLateInDetails(data: any): Observable<any> {
    // const url = `${GLOBAL.APIS.REPORTS.GET_UNITWISE_PRESENT}`;
    const url = `${GLOBAL.APIS.REPORTS.GET_UNITWISE_PRESENT_EARLY}`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
  }

  public getPlantwisepresentdetail(data: any): Observable<any> {
    // const url = `${GLOBAL.APIS.REPORTS.GET_UNITWISE_PRESENT}`;
    const url = `${GLOBAL.APIS.REPORTS.GET_PLANTWISE_PRESENT_CMN}SP_RPT_DailyPlantWisePresentDetails`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
    // map((response: any) => response.Data.Table));
  }
  public getPlantwiseTimeCardReportData(data: any): Observable<any> {
    // const url = `${GLOBAL.APIS.REPORTS.GET_UNITWISE_PRESENT}`;
    const url = `${GLOBAL.APIS.REPORTS.GET_TIMECARD_PLANTWISE_CMN}`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
    // return of([
    //   {
    //     "$id": "1", "GatePassNo": 13300013,
    //     "WorkOrder": "Agreement101",
    //     "License": "Ackow001",
    //     "ECPolicy": "-",
    //     "Plant": "Goa 2",
    //     "Unit": "Unit-10",
    //     "Department": "-",
    //     "SectionName": "-",
    //     "Day": "Sunday",
    //     "Date": "01/08/2021",
    //     "ShiftName": "GN",
    //     "ShiftTime": "08:30To 17:00",
    //     "InTime": "08:00",
    //     "OutTime": "22:00",
    //     "LateComming": "-",
    //     "EarlyGoing": "-",
    //     "WHR": "14:00",
    //     "OT": "05:00",
    //     "WorkmenCategory": "HR Associate",
    //     "ContractorName": "Adecco India Pvt Ltd",
    //     "FullName": "Anant Shantaram Chari",
    //     "Gender": "Male",
    //     "AttendanceStatus": "WP",
    //     "PFNo": null,
    //     "PFUANNo": "",
    //     "ESICNo": null,
    //     "Labour_Code": 651,
    //     "ContractorVendor_Code": 101
    //   },
    //   {
    //     "$id": "2", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10",
    //     "Department": "-", "SectionName": "-", "Day": "Monday", "Date": "02/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:43", "OutTime": "22:00", "LateComming": "00:13", "EarlyGoing": "-",
    //     "WHR": "13:17", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P", "PFNo": null,
    //     "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101
    //   }, { "$id": "3", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Tuesday", "Date": "03/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "4", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Wednesday", "Date": "04/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:43", "OutTime": "22:00", "LateComming": "00:13", "EarlyGoing": "-", "WHR": "13:17", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "5", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Thursday", "Date": "05/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "6", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Friday", "Date": "06/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "A", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "7", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Saturday", "Date": "07/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "A", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "8", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Sunday", "Date": "08/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "A", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "9", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Monday", "Date": "09/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "A", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "10", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Tuesday", "Date": "10/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "11", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Wednesday", "Date": "11/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "12", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Thursday", "Date": "12/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:35", "OutTime": "22:00", "LateComming": "00:05", "EarlyGoing": "-", "WHR": "13:25", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "13", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Friday", "Date": "13/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:47", "OutTime": "22:00", "LateComming": "00:17", "EarlyGoing": "-", "WHR": "13:13", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P½", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "14", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Saturday", "Date": "14/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "15", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Sunday", "Date": "15/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "WP", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "16", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Monday", "Date": "16/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, {
    //     "$id": "17", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-7", "Department": "-", "SectionName": "-", "Day": "Tuesday", "Date": "17/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P", "PFNo": null, "PFUANNo": "", "ESICNo": null,
    //     "Labour_Code": 651, "ContractorVendor_Code": 101
    //   }, { "$id": "18", "GatePassNo": 13300014, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Wednesday", "Date": "18/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "19", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Thursday", "Date": "19/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "20", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-7", "Department": "-", "SectionName": "-", "Day": "Friday", "Date": "20/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "08:00", "OutTime": "22:00", "LateComming": "-", "EarlyGoing": "-", "WHR": "14:00", "OT": "05:00", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "P", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "21", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "QC-X", "Department": "-", "SectionName": "-", "Day": "Saturday", "Date": "21/08/2021", "ShiftName": "GN", "ShiftTime": "08:30To 17:00", "InTime": "-", "OutTime": "17:23", "LateComming": "-", "EarlyGoing": "-", "WHR": "-", "OT": "-", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "WO", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "22", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "-", "Department": "-", "SectionName": "-", "Day": "Sunday", "Date": "22/08/2021", "ShiftName": "-", "ShiftTime": null, "InTime": "-", "OutTime": "-", "LateComming": "-", "EarlyGoing": "-", "WHR": "-", "OT": "-", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "WOD", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "23", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "QC-X", "Department": "-", "SectionName": "-", "Day": "Monday", "Date": "23/08/2021", "ShiftName": "CC", "ShiftTime": "23:00To 07:00", "InTime": "-", "OutTime": "08:40", "LateComming": "-", "EarlyGoing": "-", "WHR": "-", "OT": "-", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "A", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "24", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "Unit-10", "Department": "-", "SectionName": "-", "Day": "Tuesday", "Date": "24/08/2021", "ShiftName": "-", "ShiftTime": null, "InTime": "-", "OutTime": "-", "LateComming": "-", "EarlyGoing": "-", "WHR": "-", "OT": "-", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "½OD", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "25", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "-", "Department": "-", "SectionName": "-", "Day": "Wednesday", "Date": "25/08/2021", "ShiftName": "-", "ShiftTime": null, "InTime": "-", "OutTime": "-", "LateComming": "-", "EarlyGoing": "-", "WHR": "-", "OT": "-", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "OD", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "26", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "-", "Department": "-", "SectionName": "-", "Day": "Thursday", "Date": "26/08/2021", "ShiftName": "-", "ShiftTime": null, "InTime": "-", "OutTime": "-", "LateComming": "-", "EarlyGoing": "-", "WHR": "-", "OT": "-", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "OD", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "27", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "-", "Department": "-", "SectionName": "-", "Day": "Friday", "Date": "27/08/2021", "ShiftName": "-", "ShiftTime": null, "InTime": "-", "OutTime": "-", "LateComming": "-", "EarlyGoing": "-", "WHR": "-", "OT": "-", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "OD", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "28", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "-", "Department": "-", "SectionName": "-", "Day": "Saturday", "Date": "28/08/2021", "ShiftName": "-", "ShiftTime": null, "InTime": "-", "OutTime": "-", "LateComming": "-", "EarlyGoing": "-", "WHR": "-", "OT": "-", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "WOD", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "29", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "-", "Department": "-", "SectionName": "-", "Day": "Sunday", "Date": "29/08/2021", "ShiftName": "-", "ShiftTime": null, "InTime": "-", "OutTime": "-", "LateComming": "-", "EarlyGoing": "-", "WHR": "-", "OT": "-", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "WOD", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "30", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "-", "Department": "-", "SectionName": "-", "Day": "Monday", "Date": "30/08/2021", "ShiftName": "-", "ShiftTime": null, "InTime": "-", "OutTime": "-", "LateComming": "-", "EarlyGoing": "-", "WHR": "-", "OT": "-", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "A", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }, { "$id": "31", "GatePassNo": 13300013, "WorkOrder": "Agreement101", "License": "Ackow001", "ECPolicy": "-", "Plant": "Goa 2", "Unit": "-", "Department": "-", "SectionName": "-", "Day": "Tuesday", "Date": "31/08/2021", "ShiftName": "-", "ShiftTime": null, "InTime": "-", "OutTime": "-", "LateComming": "-", "EarlyGoing": "-", "WHR": "-", "OT": "-", "WorkmenCategory": "HR Associate", "ContractorName": "Adecco India Pvt Ltd", "FullName": "Anant Shantaram Chari", "Gender": "Male", "AttendanceStatus": "A", "PFNo": null, "PFUANNo": "", "ESICNo": null, "Labour_Code": 651, "ContractorVendor_Code": 101 }])

    // // map((response: any) => response.Data.Table));
  }
  public getCoffListingData(data: any): Observable<any> {
    // const url = `${GLOBAL.APIS.REPORTS.GET_UNITWISE_PRESENT}`;
    const url = `${GLOBAL.APIS.REPORTS.GET_COFF_LISTING_FILTERWISE}`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
    // map((response: any) => response.Data.Table));
  }
  // getCoffListingData(filterParm) {
  //   //   const model = {
  //   //     Company_Code: '',
  //   //     Plant_Code: '',
  //   //     Unit_Code: '',
  //   //     Department_Code: '',
  //   //     Section_Code: '',
  //   //     NatureOfWork_Code: '',
  //   //     // ShiftGroupType_Code: '',
  //   //     Shift_Code: '',
  //   //     IncludingSubContractor: '',
  //   //     Contractors: '',
  //   //     SubContractors: '',
  //   //     WorkOrder_Code: '',
  //   //     SubWorkOrder_Code: '',
  //   //     License_Code: '',
  //   //     SubLicense_Code: '',
  //   //     ESIC: '',
  //   //     SubESIC: '',
  //   //     WCPolicy: '',
  //   //     SubWCPolicy: '',
  //   //     Gender: '',
  //   //     Skill_Code: '',
  //   //     Trade_Code: '',
  //   //     Qulification_Code: '',
  //   //     TechQualification_Code: '',
  //   //     StreamQualification_Code: '',
  //   //     Religion_Code: '',
  //   //     Cast_Code: '',
  //   //   };
  //   //   return this.httpClient.post(`${GLOBAL.APIS.ATTENDANCE_MANAGEMENT.GET_All_ACTIVELABOUR_DATA}`, model).pipe(
  //   //     map((response: any) => response));
  //   // }

  //   const body = JSON.stringify(filterParm);
  //   httpOptions['body'] = body;
  //   return this.httpClient.request(
  //     GLOBAL.HTTP_POST,
  //     `${GLOBAL.APIS.ATTENDANCE_MANAGEMENT.GET_COFF_Filter_Data}`,
  //     httpOptions
  //   );
  // }
  // public getLabourDetails(Contractor): Observable<any[]> {

  //   const url = `${GLOBAL.APIS.COMPANY_COMMONS_MASTER.GET_EMP}`;
  //   return this.http.post(url, data).
  //   pipe(
  //     map((response: any) => response));
  // }
  // public getLabourDetails(Contractor, plantcode, unitCode, SubContractors, UserId): Observable<any[]> {

  //   const url = `${GLOBAL.APIS.COMPANY_COMMONS_MASTER.GET_EMP}`;
  //   return this.http.post(url, { Contractor, plantcode, unitCode, SubContractors, UserId }).
  //     pipe(
  //       map((response: any) => response));
  // }

  // public getLabourDetails(data: any): Observable<any[]> {

  //   const url = `${GLOBAL.APIS.COMPANY_COMMONS_MASTER.GET_EMP}`;
  //   return this.http.post(url, data).pipe(
  //     map((response: any) => response));
  // }

  // public getBalance(search, userID, roleCode, gatepass): Observable<any[]> {
  //   const url = `${GLOBAL.APIS.LABOUR_MANAGEMENT.GET_LISING_LEAVEBALANCE}`;
  //   return this.httpClient.post(url, { search, userID, roleCode, gatepass }).
  //     pipe(
  //       map((response: any) => response));
  // }

  public getDailyAbsentPresentReport(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.REPORTS.GET_DAILY_ATTENDANCE_REPORT}`;
    console.log("URL getDailyAbsentPresentReport", url);
    //   console.log('DATA getDailyPresentDetails', data);
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response.Data.Table));
  }
  // public getContractorRegisterReport(data: any): Observable<any> {
  //   const url = `${GLOBAL.APIS.REPORTS.GET_CONT_REGISTER_REPORT}`;
  //   console.log('URL getContractorRegisterReport', url);
  //   //   console.log('DATA getDailyPresentDetails', data);
  //   return this.http.post<any>(url, data).pipe(
  //     map((response: any) => response));
  // }
  // public getLabourRegisterReport(data: any): Observable<any> {
  //   const url = `${GLOBAL.APIS.REPORTS.GET_LABOUR_REGISTER_REPORT}`;
  //   console.log('URL getLabourRegisterReport', url);
  //   //   console.log('DATA getDailyPresentDetails', data);
  //   return this.http.post<any>(url, data).pipe(
  //     map((response: any) => response.Data));
  // }

  public getContractorRegisterReport(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}SP_RPT_ContractorRegisterReport`;
    return this.http.post(url, data).pipe(map((response: any) => response));
  }

  public getLabourRegisterReport(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}CLPMS_SP_RPT_WorkmanRegister`;
    return this.http.post(url, data).pipe(map((response: any) => response));
  }

  public getManpowerSummaryAnnualHalfYearly(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}RPT_YY_Manpower_Summary`;
    return this.http.post(url, data).pipe(map((response: any) => response));
  }

  public getManpowerReqStatusD2D(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.REPORTS.GET_MANPOWER_REQ_STATUS_D2D_LIST}`;
    return this.http.post(url, data).pipe(map((response: any) => response));
  }

  public getMonthlyAttendanceReport(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.REPORTS.GET_MONTHLY_ATTENDANCE_REPORT}`;
    console.log("URL getMonthlyAttendanceReport", url);
    // console.log('DATA getDailyPresentDetails', data);
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response.Data.objContractor));
  }
  public getDailyRequirementReport(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}SP_RPT_GetDailyRequirement`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
  }
  public getWorkOrdersByContractorCode(
    contractorCode: number,
    plantcode: number
  ): Observable<any> {
    const req = {
      Role_Code: null,
      UserId: null, //`${GLOBAL.USER.LOGGED_IN_USER}`,
      ContractorVendor_Code: contractorCode,
      SubContractorVendor_Code: null,
      ActionType: 1,
      WorkOrder_Code: null,
      Plant_Code: plantcode,
      Search: null,
      selectedField: null,
    };
    const url = `${GLOBAL.APIS.WORK_ORDER.SP_GET_CONTRACTOR_WISE_WORK_ORDER_LIST}`;
    return this.http.post<any>(url, req).pipe(map((response: any) => response));
  }
  public getWorkorders(): Observable<any> {
    const url = `${GLOBAL.APIS.WORK_ORDER.GET_WORK_ORDERS}`;
    return this.http.get<any>(url).pipe(map((response: any) => response.Data));
  }
  public getSubContractorByWODataforDA(
    contractorCode: number,
    workOrderNo: number
  ): Observable<Contractor[]> {
    const url = `http://cmmsborlapi.spikyarc.com/api/UserManagement/GetSubContractorByWODataforDA?contractorCode=
    ${contractorCode}&workOrder=${workOrderNo}`;
    return this.http
      .request<Contractor[]>(GLOBAL.HTTP_GET, url)
      .pipe(
        map((items: any[]) =>
          items.map((item: any) => this.adapter.toContractorResponse(item))
        )
      );
  }
  public getSectionFirstLevel(
    plantCode: any,
    unitCode: any,
    departmentCode: any
  ): Observable<any> {
    // currently there is not data for current user, so set the user id = 1

    const url = `${
      GLOBAL.APIS.MASTER_DATA.GET_SECTION_FIRST_LEVEL
    }?userId=${localStorage.getItem("UserID")}&plantCode=${plantCode}
    &unitCode=${unitCode}&departmentCode=${departmentCode}`;
    console.log(url);
    return this.httpClient.get(url).pipe(map((response: any) => response.Data));
  }

  public getCompanies(): Observable<any[]> {
    const req = {
      Search: null,
      StatusOfIndustry: null,
      EntityType: null,
      Legalstatus: null,
      State: null,
      City: null,
      Country: null,
    };
    const url = `${GLOBAL.APIS.COMPANY_COMMONS_MASTER.GET_COMPANY_MASTER_DATA_SP}`;
    return this.http
      .post<any[]>(url, req)
      .pipe(map((response: any) => response));
  }

  getLicenses(contractorCode: any) {
    const url = `${GLOBAL.APIS.LICENSE.GET_LICENSE}?search=&sDate=&eDate=&selectedField=&filterType=&condition=&State_Code=
                &Status_Code=&Plant_Code=&IsActive=&NatureOfLicense_Code=&NatureOfWork_Code=&TotalAccupied=
                &Contractor_Code=${contractorCode}&SubContractor_Code=&WorkOrder_Code=&SubWorkOrder_Code=&isContractorType=&UserId=`;
    return this.http
      .post(url, {})
      .pipe(map((response: any) => response.Data.Table));
  }

  getWCPolicy(contractorCode: any) {
    const url = `${GLOBAL.APIS.REPORTS.GET_WC_POLICY}?search=&sDate=&eDate=&selectedField=&filterType=&condition=&State_Code=
                &Status_Code=&Plant_Code=&IsActive=&NatureOfWork_Code=&TotalAccupied=
                &Contractor_Code=${contractorCode}&SubContractor_Code=&WorkOrder_Code=&SubWorkOrder_Code=&isContractorType=&UserId=`;
    return this.http.get(url).pipe(map((response: any) => response.Data.Table));
  }

  // public getPlants(companyCode: any): Observable<any[]> {
  //   const url = `${GLOBAL.APIS.MASTER_DATA.GET_PLANTS}?Search=&Company=${companyCode}&State=&City=&Country=&SDate=&EDate=
  //   &UnitType=&Ownership=&LocatedAt=&ISESICApplicable=`;
  //   return this.http.get<any[]>(url).pipe(
  //     map((response: any) => response));
  // }

  public geAnomalyData(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}SP_RPT_Anomaly_Data_Report_Temp`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
  }

  public getPlants(companyCode: any): Observable<any[]> {
    const req = {
      search: null,
      Company: companyCode,
      State: null,
      City: null,
      Country: null,
      UnitType: null,
      OwnerShip: null,
      LocatedAt: null,
      IsESICApplicable: null,
    };
    const url = `${GLOBAL.APIS.COMPANY_COMMONS_MASTER.GET_PLANT_MASTER_DATA}`;
    return this.http
      .post<any[]>(url, req)
      .pipe(map((response: any) => response));
  }

  public getPageNPrintConfig(): Observable<any[]> {
    const req = {
      Page_Code: 104, 
      RequireType: 1, 
      ActionType: 1, 
      UserID: localStorage.getItem("UserID")
    };
    const url = `${GLOBAL.APIS.COMMON_GLOBAL_VAR.PAGE_NPRINT_CONFIG}`;
    return this.http
      .post<any[]>(url, req)
      .pipe(map((response: any) => response));
  }

  public getStates(): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_STATE}?Search=&CountryCode=`;
    console.log(url);
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }
  public getStatesList(plantCode: any): Observable<any[]> {
    const req = {
      // "Search": "",
      // "Plant_Code": plantCode
      Search: "",
      selectedField: null,
      State_Code: "",
      Plant_Code: plantCode,
      RequireType: 0,
      ActionType: 0,
      UserId: 100,
    };
    const url = `${GLOBAL.APIS.COMPANY_COMMONS_MASTER.GET_STATE_DATA_SP}`;
    console.log(url);
    return this.http
      .post<any[]>(url, req)
      .pipe(map((response: any) => response));
  }
  public getUnits(plantCode: any): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_UNITS}?Search=&PlantCode=${plantCode}`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }

  public getDesignations(companyCode: any): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DESIGNATION}?Search=&companyCode=${companyCode}&GradeCode=&LevelCode=`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }

  // public getStateList(plantCode): Observable<any> {
  //   const model = {
  //     Search: '',
  //     Plant_Code: JSON.stringify(plantCode),
  //   };
  //   return this.httpClient.post(`${GLOBAL.APIS.COMPANY_COMMONS_MASTER.GET_STATE_LIST_PLANTWISE}`, model).pipe(
  //     map((response: any) => response));
  // }

  // public getMasterItemByCode(code: string): Observable<any[]> {
  //   const url = `${GLOBAL.APIS.MASTER_DATA.GET_MASTERITEMLIST}?Search=&ShortCode=${code}`;
  //   return this.http.get<any[]>(url).pipe(
  //     map((response: any) => response));
  // }

  public getMasterItemByCode(code: string): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_MASTERITEMLIST}?Search=&ShortCode=${code}`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }
  getDepartmentData(unit) {
    const model = {
      Unit_Code: "",
    };
    return this.httpClient
      .post(`${GLOBAL.APIS.LABOUR_MANAGEMENT.GET_DEPARTMENT_BY_UNIT}`, model)
      .pipe(map((response: any) => response));
  }

  public getDepartments(unitCode: any): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DEPARTMENTS_FTR}?unitCode=${unitCode}`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data));
  }

  // public getDepartments(unitCode: any): Observable<any[]> {

  //   const url = `${GLOBAL.APIS.MASTER_DATA.GET_DEPARTMENTS_FTR}?unitCode=${unitCode}`;
  //   return this.http.get<any[]>(url).pipe(
  //     map((response: any) => response.Data.Table));
  // }
  public getDepartmentss(
    plantCode: any = "",
    unitCode: any = ""
  ): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DEPARTMENTS}?Search=&PlantCode=${plantCode}&UnitCode=${unitCode}`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }
  public getDepartmentPlantUnitSectionTree(
    plantCode: any,
    unitCode: any,
    departmentCode: any
  ): Observable<any> {
    // currently there is not data for current user, so set the user id = 1
    // const url = `${GLOBAL.APIS.MASTER_DATA.GET_DEPARTMENT_PLANT_UNIT_SECTION_TREE}?userId=${localStorage.getItem('UserID')}`;
    const url = `${
      GLOBAL.APIS.MASTER_DATA.GET_DEPARTMENT_PLANT_UNIT_SECTION_TREE
    }?userId=${localStorage.getItem("UserID")}
    &plantCode=${plantCode}&unitCode=${unitCode}&departmentCode=${departmentCode}`;
    console.log("url", url);
    return this.http.get(url).pipe(map((response: any) => response.Data));
  }

  public getWorkingWeekOffDataDetails(WEEKOFF_DATA): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_WORKING_WEEKOFF_DATA}`;
    return this.http.post(url, WEEKOFF_DATA);
  }
  public getSections(): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_SECTION}?Search=`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }

  public getNatureOfWorks(): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_NATUREOFWORKS}?Search=`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }

  public getShiftTypes(): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_SHIFTTYPES}?Search=`;
    return this.http.get<any[]>(url).pipe(map((response: any) => response));
  }
  public getShiftGroupTypes(): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_SHIFTGROUPTYPES}?Search=`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }
  public getShifts(plantCode: any, shiftTypeGroupCode: any): Observable<any[]> {
    console.log("getShifts:plantCode", plantCode);
    console.log("getShifts:shiftTypeGroupCode", shiftTypeGroupCode);
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_SHIFTS}?Search=&PlantCode=${plantCode}&ShiftTypeGroupCode=${shiftTypeGroupCode}`;
    console.log("getShifts:url", url);
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }

  public getSkills(): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_SKILLS}?Search=&PlantCode=&ParentSkillCode=&TradeCode=`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }

  public addFilter(data: any): Observable<any[]> {
    const url = `${
      GLOBAL.APIS.REPORTS.ADD_FILTER
    }?User_Code=${localStorage.getItem("UserID")}
    &Page_Code=${data.Page_Code}&FilterName=${
      data.FilterName
    }&JSONTextDetails=${data.JSONTextDetails}`;
    return this.http.post(url, {}).pipe(map((response: any) => response));
  }

  public updateFilter(data: any): Observable<any[]> {
    const url = `${GLOBAL.APIS.REPORTS.UPDATE_FILTER}?Report_Code=${
      data.Report_Code
    }&User_Code=${localStorage.getItem("UserID")}
    &Page_Code=${data.Page_Code}&FilterName=${
      data.FilterName
    }&JSONTextDetails=${data.JSONTextDetails}`;
    return this.http.post(url, {}).pipe(map((response: any) => response));
  }

  // public deleteFilter(data: any): Observable<any[]> {
  //   const url = `${GLOBAL.APIS.REPORTS.DELETE_FILTER}?Report_Code=${data.Report_Code}&User_Code=${localStorage.getItem('UserID')}`;
  //   return this.http.post(url, {}).pipe(
  //     map((response: any) => response.Data));
  // }
  public deleteFilter(data: any): Observable<any[]> {
    // tslint:disable-next-line: max-line-length
    const url = `${GLOBAL.APIS.REPORTS.DELETE_FILTER_PAGEWISE}?Report_Code=${
      data.Report_Code
    }&User_Code=${localStorage.getItem("UserID")}&Page_Code=${data.Page_Code}`;
    return this.http.post(url, {}).pipe(map((response: any) => response));
  }
  public getALLSavedFilterDescripation(): Observable<any[]> {
    const url = `${
      GLOBAL.APIS.REPORTS.GET_FILTER
    }?User_Code=${localStorage.getItem("UserID")}`;
    return this.http
      .get(url)
      .pipe(
        map((response: any) =>
          response.map((item: any) => this.adapter.parseJsonString(item))
        )
      );
  }
  public getALLSavedFilterDescripationUserWise(
    pagecode: number
  ): Observable<any[]> {
    const url = `${
      GLOBAL.APIS.REPORTS.GET_FILTER_PAGEWISE
    }?User_Code=${localStorage.getItem("UserID")}&Page_Code=${pagecode}`;
    return this.http
      .get(url)
      .pipe(
        map((response: any) =>
          this.adapter
            .convertResponse(response)
            .map((item: any) => this.adapter.parseJsonString(item))
        )
      );
  }
  public getState(): Observable<any[]> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_STATE}?Search=`;
    return this.http
      .get<any[]>(url)
      .pipe(map((response: any) => response.Data.Table));
  }
  public getGatapassMasterData(data: any): Observable<any> {
    // const url = `${GLOBAL.APIS.REPORTS.GET_GATEPASS_MASTER_DATA}`;
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}SP_RPT_GetGatePassMasterData`;
    return this.http.post<any>(url, data);
  }
  // tslint:disable-next-line: function-name
  public GetLicenceExpiryData(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}SP_RPT_LicenceExpiry`;
    return this.http.post(url, data);
  }
  // tslint:disable-next-line: function-name
  public GetEcpolicyExpiryData(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}SP_RPT_EcpolicyExpiry`;
    return this.http.post(url, data);
  }
  // tslint:disable-next-line: function-name
  public GetWorkOrderExpiryData(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}SP_RPT_WorkOrderExpiry`;
    return this.http.post(url, data);
  }
  public getTotalDailyRequirementData(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}SP_RPT_ManPowerRequitionVSRequest`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
    //  return of(this.totalPlantWiseData());
  }

  public getContractorSubContractorData(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}SP_RPT_FILTER_ContractorAndSubContractor`;
    return this.http
      .post<any>(url, data)
      .pipe(map((response: any) => response));
    //  return of(this.totalPlantWiseData());
  }

  private convertToExtraWorkingHrDetails(item: any): any {
    item.Date = item.Date ? new Date(item.Date) : null;
    return item;
  }

  // public getContractorWiseWCPolicyDetails(data: any): Observable<any> {
  //   const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}SP_RPT_ContractorWiseWCPolicyDetails`;
  //   return this.http.post<any>(url, data).pipe(
  //     map((response: any) => response.Data));
  // }

  public getContractorWiseWCPolicyDetails(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}SP_RPT_ContractorWiseWCPolicyDetails`;
    return this.http.post(url, data);
  }
  // tslint:disable-next-line: function-name
  public GetContractorWiseExpiryData(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.MASTER_DATA.GET_DATA_BY_SP}SP_RPT_Contractor_Wise_Expiry_Noti`;
    return this.http.post(url, data);
  }

  public getProfileNotFoundList(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.REPORTS.GET_PROFILE_NOT_FOUND_LIST}`;
    return this.http.post<any>(url, data);
  }

  public getWageReportData(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.REPORTS.GET_WORKMEN_PAYROLL_MM}`;
    return this.http.post<any>(url, data);
  }
  // public getWageReportData(data: any): Observable<any> {
  //   const url = `${GLOBAL.APIS.REPORTS.GET_WAGE_REPORT_DATA}`;
  //   return this.http.post<any>(url, data);
  // }

  public getWageReportHeaderDetails(data: any): Observable<any> {
    const url = `${GLOBAL.APIS.REPORTS.CLPMS_SP_ReportHeaderDetails}`;
    return this.http.post<any>(url, data);
  }
}
